import Inputmask from "inputmask";

export default {
    'settings.annonce': {
        required: false,
    },
    'tournament.title': {},
    'tournament.date_date': {},
    'tournament.date_time': {},
    'tournament.youtube_id': {
        required: false,
        // mask: (input) => {
        //     input.placeholder = 'https://www.youtube.com/embed/__'
        //     return Inputmask('https://www.youtube.com/embed/*{2,}', {
        //         greedy: false,
        //     }).mask(input)
        // }
    },
    'tournament.competition_format': {
        required: true,
        appearsOn: {
            models: ['settings.annonce'],
            callback: (computed) => {
                return computed.settings_annonce === true
            }
        },
    },
}